import { NewPasswordForm } from "../../components/auth/resetPassword/NewPasswordForm";

export const NewPassword = () => {
  return (
   <NewPasswordForm/>
  );
};
